import React, { useState, useEffect } from "react";

import Tabpayment from "../../components/Payment/tab_payment";
import "../../assets/css/styles.css";
import "../../assets/libs/bootstrap/css/bootstrap.min.css";
import Spinner from "../../components/Spinner/spinner";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
const Payment = () => {
  const [loading, setLoading] = useState(true);
  const [showSpinner, setShowSpinner] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    const token = localStorage.getItem(`${process.env.REACT_APP_LOCAL_TOKEN}`);
    const token_horoscope = localStorage.getItem(`${process.env.REACT_APP_LOCAL_TOKEN_HOROSCOPE}`);
    if (!token && !token_horoscope) {
      navigate("/signin", { replace: true });
    }
  }, []);


  return <>
{/*   {showSpinner ? <Spinner /> :  */}
  <Tabpayment />
  {/* } */}
  </>;
};

export default Payment;
